import type { ThreadStatus } from "@/types/thread.ts";

const statusLabels: Record<ThreadStatus, string> = {
  "to-review": "Review",
  "in-progress": "In Progress",
  completed: "Completed",
  draft: "Draft",
  dead: "Dead",
};

/**
 * The display label for a thread's lifecycle status. Shared so a thread reads
 * the same wherever it is listed — web's thread rows and Routines view, and the
 * Artifact Library's thread results on both web and native.
 */
export const formatThreadStatus = (status: ThreadStatus): string => statusLabels[status];
